// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HaHh","left":"styles_left__3iR1j"};